<template>
    <div>
        <el-dialog title="查看筛选项" :visible.sync="visible" width="500px" :close-on-click-modal="false">
            <Language v-model="lang" @change="handleLangChange" style="margin-top: -20px"></Language>
            <el-form style="margin-bottom: 20px">
                <el-form-item style="margin-bottom: 0" label="排序">{{ info.sort }}</el-form-item>
                <el-form-item style="margin-bottom: 0" label="筛选项名称">{{ info.name }}</el-form-item>
                <el-form-item style="margin-bottom: 0" label="是否显示"><el-switch disabled v-model="info.status"> </el-switch></el-form-item>
            </el-form>
            <el-row type="flex" justify="space-between">
                <div>参数配置</div>
                <el-button size="small" type="primary" @click="handleAdd">添加</el-button>
            </el-row>
            <ListPage :search="false" :page="false" :data="info.item">
                <template slot="columns">
                    <el-table-column prop="uuid" label="ID" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="name" label="参数值"></el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
                            <el-button type="text" @click="handleDel(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </template>
            </ListPage>
        </el-dialog>
        <ItemVue ref="item" @update="search"></ItemVue>
    </div>
</template>

<script>
import { detail, delItem } from "@/api/product/filter";
import Language from "@/components/Language";
import ItemVue from "./item.vue";
import listMixin from "@/mixins/list";
export default {
    components: { Language, ItemVue },
    mixins: [listMixin],
    data() {
        return {
            del: delItem,
            visible: false,
            lang: "zh",
            info: {},
            module: "参数值",
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            this.info.cuuid = row.cuuid;
            this.search();
        },
        handleLangChange(lang) {
            this.lang = lang;
            this.search();
        },
        search() {
            detail({ cuuid: this.info.cuuid, lang: this.lang }).then(({ code, result, error }) => {
                if (code == 200) {
                    this.info = result ? { ...result, status: result.status == 1 } : { cuuid: this.info.cuuid, lang: this.lang };
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleAdd() {
            this.$refs.item.open(null, this.info.uuid);
        },
        handleEdit(row) {
            this.$refs.item.open(row);
        },
    },
};
</script>

<style></style>
